import { useRef, useState } from "react";

function CommodityTableRow({ index, productGroupName, commodityListItem, handleSubmit, setError, t, setAdd, setEdit, oddIdx }) {
	const [commodityName, setCommodityName] = useState((commodityListItem && Object.keys(commodityListItem).length > 0)?commodityListItem.commodityName:"");
	const [description, setDescription] = useState((commodityListItem && Object.keys(commodityListItem).length > 0)?commodityListItem.description:"");
	const [isSubmit, setIsSubmit] = useState(false);
	const commodityNameRef = useRef(null);
	const descriptionRef = useRef(null);

	function commodityNameHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedCommodityName = e.target.value;
		setCommodityName(selectedCommodityName);
	}

	function descriptionHandler(e) {
		e.preventDefault();
		e.stopPropagation();
		let selectedDescription = e.target.value;
		setDescription(selectedDescription);
	}
	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let action = 1;
		let commodityKey = 0;
		let commodityNameSet = commodityNameRef.current.value;
		let descSet = descriptionRef.current.value;
		if((commodityListItem && Object.keys(commodityListItem).length > 0)){
			action = 2;
			commodityKey = commodityListItem.commodityKey;
		}
		if (typeof descSet === 'undefined') {
			descSet = "";
		}
		if ((typeof commodityNameSet === 'undefined') || !commodityNameSet || !commodityNameSet.trim()) {
			setError(t("error.commoName.Reqd"));
			setIsSubmit(false);
		} else {
			let initialValues = {
				commodityKey: commodityKey,
				commodityName: commodityNameSet.trim(),
				description: descSet.trim(),
				action: action
			};
			handleSubmit(action, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
		setIsSubmit(false);
		setEdit(false);
	}
	return (
		<tr key={index}>
		    <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{productGroupName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="text"
					name="commodityName"
					id="commodityName"
					value={commodityName}
					maxLength="50"
					className="form-control rounded-pill shadow-sm px-4 "
					ref={commodityNameRef}
					onChange={(e) => (commodityNameHandler(e))}
					style={{ maxWidth: "20vw" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="text"
					name="description"
					id="description"
					value={description}
					maxLength="100"
					className="form-control rounded-pill shadow-sm px-4 "
					ref={descriptionRef}
					onChange={(e) => (descriptionHandler(e))}
					style={{ maxWidth: "20vw" }}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default CommodityTableRow;